import { LabelledEntity } from 'shared/types/commonView';
import { LabelledUser } from '../../user/mapping/toView';
import { UserAccess } from '../mapping/accessLevel/toOnView/types';
import { canBeGrantedEditAccess } from './canBeGrantedEditAccess';

export function findMentionedUsersWithoutEditPermissionAndWithProjectAccess(
  availableUsers: LabelledUser[],
  mentionedUsersUnique: LabelledEntity[],
  userAccesses: UserAccess[]
): LabelledEntity[] {
  return mentionedUsersUnique.filter((user) =>
    canBeGrantedEditAccess(availableUsers, user, userAccesses)
  );
}
